import * as React from 'react';
import classNames from 'classnames';
import Label from '../Label';

enum LabelPosition {
  RIGHT = 'right',
  LEFT = 'left',
}

export interface ControlledToggleProps {
  value: boolean;
  onChange: (e?: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  labelPosition?: LabelPosition;
  className?: string;
  disabled?: boolean;
  name: string;
}

const ControlledToggle: React.FC<ControlledToggleProps> = (
  props: ControlledToggleProps
) => {
  const {
    name,
    label = '',
    labelPosition = LabelPosition.LEFT,
    disabled,
    value,
    onChange,
    className,
    ...otherProps
  } = props;

  const toggleClassNames = classNames('ui-toggle', className, {
    'ui-toggle--disabled': disabled,
    'ui-toggle--on': Boolean(value),
  });

  const ToggleComponent = (
    <div className={toggleClassNames}>
      <input
        disabled={disabled}
        id={name}
        name={name}
        type="checkbox"
        className="ui-toggle-input"
        {...otherProps}
        checked={value}
        onChange={onChange}
      />
      <span className="ui-toggle-outline" />
      <span className="ui-toggle-thumb" />
    </div>
  );

  if (label) {
    return (
      <div className="ui-toggle-wrap">
        {label && labelPosition === LabelPosition.LEFT && (
          <Label id={name} label={label} />
        )}
        {ToggleComponent}
        {label && labelPosition === LabelPosition.RIGHT && (
          <Label id={name} label={label} />
        )}
      </div>
    );
  }

  return ToggleComponent;
};

export default ControlledToggle;
